import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors,
    Table,
    TableHead,
    TableCell,
    Modal,
    Backdrop,
    TableBody,
    TableRow
} from '@material-ui/core';
import { add_showroom_unit } from '../../../../api/API';


const useStyles = makeStyles(theme => ({
    root: {
        // position: 'absolute',
        // top: '50%',
        // left: '50%',
        // transform: 'translate(-50%, -50%)',
        // outline: 'none',
        // boxShadow: theme.shadows[20],
        // width: 700,
        // maxHeight: '100%',
        // overflowY: 'auto',
        // maxWidth: '100%'
    },

    closeButton: {
        color: theme.palette.white,
        backgroundColor: 'black',
        '&:hover': {
            backgroundColor: "black"
        },

    },

    flexend: {
        justifyContent: 'flex-end',
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));

export default function AddShowflat(props) {
    const { profile, className, onClose, agencies, property_id, ...rest } = props;

    const classes = useStyles();
    const [isOpen, setisOpen] = useState(props.open);
    const [values, setValues] = useState({
        name: ""
    });

    const [openSnackbar, setOpenSnackbar] = useState(false);

    useEffect(() => {
        console.log(props);

    });

    const history = useHistory();

    const handleChange = event => {
        event.persist();

        setValues({
            ...values,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        });
    };

    const handleSubmit = async event => {
        event.preventDefault();
        let response = await add_showroom_unit({
            property_id: property_id,
            name: values.name
        });
        if (response) {
            onClose();
        }

    };

    const handleOpen = () => {
        setisOpen(true);
    }
    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };


    const handleClose = () => {
        setisOpen(false);
        onClose();

    };



    return (
        <Backdrop container
            open={isOpen}
            onClick={(e) => {
                handleClose();
            }}

        >
            <Modal
                open={isOpen}
                onClick={(e) => {
                    e.stopPropagation();
                }}
                style={{
                    width: "60%",
                    marginLeft: "20%",
                    marginTop: "15%"

                }}
            >

                <form onSubmit={handleSubmit}>
                    <Card
                        {...rest}
                        className={clsx(classes.root, className)}
                    >
                        <CardHeader title="Add Showflat">

                        </CardHeader>
                        <Divider />
                        <CardContent>
                            <Grid
                                container
                                spacing={4}
                            >


                                <Grid
                                    item
                                    md={12}
                                    xs={12}
                                >
                                    <TextField
                                        fullWidth
                                        label="Unit name"
                                        name="name"
                                        onChange={handleChange}
                                        value={values.name}
                                        variant="outlined"
                                    >
                                    </TextField>

                                </Grid>
                            </Grid>
                        </CardContent>
                        <Divider />
                        <CardActions className={classes.flexend}>
                            <Button
                                className={classes.closeButton}
                                type="button"
                                variant="contained"
                                onClick={handleClose}
                            >
                                <CloseIcon />
                                <span className="hide_mobile">
                                    Close</span>
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"

                            >
                                <SaveIcon />
                                <span className="hide_mobile">
                                    Save Changes</span>
                            </Button>
                        </CardActions>
                    </Card>


                </form>

            </Modal>

        </Backdrop >
    )
}

